import type { ReactNode } from 'react';
import { cardTight, sectionTitle } from '../../uiStyles';

export type GradeSummaryStat = {
  label: string;
  value: ReactNode;
  helper?: string;
};

type GradeSummaryStatsProps = {
  title?: string;
  stats: GradeSummaryStat[];
};

export function GradeSummaryStats({ title = 'Summary', stats }: GradeSummaryStatsProps): ReactNode {
  return (
    <section className={cardTight}>
      <p className={sectionTitle}>{title}</p>
      <div className="mt-2 grid grid-cols-3 gap-2">
        {stats.map((s) => (
          <div
            key={s.label}
            className="rounded-xl border border-slate-200/70 bg-white/80 p-2.5 dark:border-slate-700/70 dark:bg-slate-900/70"
          >
            <p className="text-[10px] font-black uppercase tracking-widest text-slate-500">
              {s.label}
            </p>
            <p className="mt-1 text-base font-black text-slate-900 dark:text-slate-100">
              {s.value}
            </p>
            {s.helper ? (
              <p className="mt-0.5 text-[10px] font-semibold text-slate-500 dark:text-slate-400">
                {s.helper}
              </p>
            ) : null}
          </div>
        ))}
      </div>
    </section>
  );
}
